import styled from "styled-components"
import "react-date-range/dist/styles.css" // main style file
import "react-date-range/dist/theme/default.css" // the

const DateRangeCalendarStyled = styled.div`
  margin: 10px 0;
`

export default DateRangeCalendarStyled
